import { Type } from "class-transformer";
import { EnaioObjectIdAndType } from "./EnaioObjectIdAndType";

export class EnaioObjectParentRelation {
    objectId = 0;
    folderId = 0;
    @Type(() => EnaioObjectIdAndType)
    register: EnaioObjectIdAndType;
}
